import { NextServicesClient } from 'online-customer-services-ts'

import { PPSOPackage, PPSOPackageRequestDto } from '@/core/ppso-package/domain/PPSO-Package.ts'
import { PPSOPackageRepository } from '@/core/ppso-package/domain/PPSOPackageRepository.ts'

export class PPSOPackageRepositoryBackendClient implements PPSOPackageRepository {
  private readonly nextServiceClient: NextServicesClient

  constructor(url: string) {
    this.nextServiceClient = new NextServicesClient(url)
  }

  async getAllPPSOPackages(payload: PPSOPackageRequestDto): Promise<PPSOPackage[]> {
    const { brandCode, culture, hostId, mileage, vin, workshopId } = payload
    const { services: packages } = await this.nextServiceClient.getNextServices(
      vin,
      mileage,
      workshopId,
      brandCode,
      culture,
      hostId
    )

    return (
      packages?.map((ppsoPackage) => {
        return {
          denomination: ppsoPackage.denomination ?? '',
          id: ppsoPackage.packageId ?? '',
          packageNumber: ppsoPackage.packageNumber ?? '',
          positions: ppsoPackage.positions ?? [],
          udt: ppsoPackage.udt || NaN
        }
      }) || []
    )
  }
}
